<template>
  <div class="slim-mainpanel">
    <div class="container">
      <div class="slim-pageheader">
        <ol class="breadcrumb slim-breadcrumb">
          <li class="breadcrumb-item"><a href="#">Operacional</a></li>
          <li class="breadcrumb-item"><a href="#">Relatórios</a></li>
          <li class="breadcrumb-item active" aria-current="page">
            Relatório de Conquistas
          </li>
        </ol>
        <h6 class="slim-pagetitle">Relatório de Conquistas</h6>
      </div>

      <div class="bd bd-1 bd-b-0">
        <div
          class="bd-t bd-5 bd-gray-800 pd-x-10 bg-white d-flex justify-content-between align-items-center pd-b-5 pd-t-5"
        >
          <ul class="nav gap1">
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo">
                <a href="#" class="dd-link" data-toggle="dropdown">
                  <div
                    v-if="filter.date.start !== '' && filter.date.end !== ''"
                  >
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-calendar"></i> Período:
                      <span
                        class="pd-x-5 badge mg-b-0 mg-r-2-force tx-thin-force"
                      >
                        {{ filter.date.start | moment("DD/MM/YYYY") }} até
                        {{ filter.date.end | moment("DD/MM/YYYY") }}
                      </span>
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span> <i class="fa fa-calendar mg-r-5"></i> Período</span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-400" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Data do Período
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione uma data inicial e final
                  </p>

                  <div class="form-layout form-layout-2 modify">
                    <div class="row no-gutters">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="form-control-label">
                            Data Inicial <span class="tx-danger">*</span></label
                          >
                          <date-picker
                            lang="pt-br"
                            v-model="filter.date.start"
                            name="startDate"
                            format="DD/MM/YYYY"
                            placeholder="Data Inicial"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="col-md-6 mg-t--1 mg-md-t-0">
                        <div class="form-group mg-md-l--1">
                          <label class="form-control-label">
                            Data Final <span class="tx-danger">*</span></label
                          >
                          <date-picker
                            lang="pt-br"
                            v-model="filter.date.end"
                            name="endDate"
                            format="DD/MM/YYYY"
                            placeholder="Data Final"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo" data-pesistent>
                <a href="#" class="dd-link tx-light" data-toggle="dropdown">
                  <div v-if="filter.customers.length > 0">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-building tx-danger mg-r-5"></i>Clientes:
                      <span
                        class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force"
                        v-for="c in filter.customers"
                        :key="c.id"
                      >
                        {{ c.name }}</span
                      >
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span
                      ><i class="fa fa-building tx-medium mg-r-5"></i> Clientes
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Clientes
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um ou mais clientes ({{
                      listOfCustomers.length
                    }}
                    encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label"> Clientes </label>
                          <v-select
                            v-model="filter.customers"
                            label="name"
                            :options="optionsCustomers"
                            name="customers"
                            multiple
                            :on-search="getCustomers"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="mg-t-5">
              <div class="dropdown dropdown-demo" data-pesistent>
                <a href="#" class="dd-link tx-light" data-toggle="dropdown">
                  <div v-if="filter.team">
                    <span class="mg-l-0 pd-l-0">
                      <i class="fa fa-users tx-danger mg-r-5"></i>Time Operacional:
                      <span
                        class="pd-x-5 badge badge-danger mg-b-0 mg-r-2-force tx-thin-force"
                      >
                        {{ filter.team.name }}</span
                      >
                      <i class="fa fa-angle-down mg-l-5"></i>
                    </span>
                  </div>

                  <div v-else>
                    <span
                      ><i class="fa fa-users tx-medium mg-r-5"></i> Time Operacional
                    </span>
                    <i class="fa fa-angle-down mg-l-5"></i>
                  </div>
                </a>
                <div class="dropdown-menu pd-15 wd-500" @click.stop="keepOpen">
                  <h6 class="tx-gray-800 tx-uppercase tx-bold mg-b-0 mg-t-10">
                    Time Operacional
                  </h6>
                  <p class="tx-gray-600 mg-b-10">
                    Selecione um time ({{ listOfTeams.length }} encontrados)
                  </p>

                  <div class="form-layout form-layout-2">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="form-control-label">
                            Time Operacional
                          </label>
                          <v-select
                            v-model="filter.team"
                            label="name"
                            :options="optionsTeams"
                            name="team"
                            :on-search="getTeams"
                          >
                            <template slot="option" slot-scope="option">
                              {{ option.name }}
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <ul class="nav nav-white-800 flex-column flex-md-row tx-white tx-15">
            <li class="mg-l-10">
              <div class="btn-group" role="group" aria-label="Ações">
                <download-excel
                  v-if="listOfResults.length > 0"
                  :data="excelData"
                  :fields="excelFields"
                  class="btn btn-success pd-x-20 mg-r-10"
                  name="relatorio-de-conquistas.xls"
                >
                  <i class="fa fa-file-excel-o mg-r-5"></i> EXCEL
                </download-excel>
                <button
                  type="button"
                  class="btn btn-primary pd-x-20"
                  @click.prevent="generate"
                >
                  <i class="fa fa-file-code-o mg-r-5"></i> GERAR
                </button>
              </div>
            </li>
          </ul>
        </div>

        <div class="section-wrapper mg-t-0 pd-0 bd-1 bd-l-0 bd-r-0 bd-b-1">
          <div class="pd-10 mg-10">
            <label class="section-title mg-t-10 tx-16">
              Resultado da Consulta
            </label>
            <p class="mg-b-0">
              Foram encontradas {{ listOfResults.length }} conquistas de acordo
              com o filtro acima.
            </p>
            <hr />
            <div class="table-responsive">
              <table class="table table-striped mg-b-0 tx-gray-800 tx-12">
                <thead>
                  <tr>
                    <th class="tx-center">Processo</th>
                    <th v-if="showCustomerColumn" class="tx-center">Cliente</th>
                    <th class="tx-center">Time/Equipe</th>
                    <th class="tx-center">Descrição</th>
                    <th class="tx-center">Data</th>
                    <th class="tx-center">Origem</th>
                    <th class="tx-center">Tipo</th>
                    <th class="tx-right" style="width: 80px;">Valor R$</th>
                    <th class="tx-center">Criada por</th>
                  </tr>
                </thead>
                <tbody
                  v-if="listOfResults != null && listOfResults.length > 0"
                >
                  <tr v-for="result in listOfResults" :key="result.id">
                    <td class="tx-center tx-uppercase tx-bold">
                      <a
                        v-if="result.process && result.process.identification"
                        href="#"
                        @click.prevent="
                          findProcessByIdentificationSearch(
                            result.process.identification
                          )
                        "
                      >
                        {{
                          ProcessService.getTypeOfProcessReference(
                            result.process
                          )
                        }}
                      </a>
                      <span v-else>-</span>
                    </td>
                    <td v-if="showCustomerColumn" class="tx-center">
                      {{ getCustomerName(result) }}
                    </td>
                    <td class="tx-center">
                      {{ result.team ? result.team.name : "-" }}
                    </td>
                    <td
                      class="valign-middle tx-center"
                      v-html="result.description"
                    ></td>
                    <td class="tx-center">
                      {{ result.date | moment("DD/MM/YYYY") }}
                    </td>
                    <td class="valign-middle tx-center tx-uppercase">
                      {{ result.source }}
                    </td>
                    <td class="valign-middle tx-center">
                      {{ result.type }}
                    </td>
                    <td class="valign-middle tx-center tx-right">
                      {{ result.value | numeralFormat("0,0.00") }}
                    </td>
                    <td class="valign-middle tx-center">
                      {{ result.createdBy }}
                    </td>
                  </tr>
                </tbody>

                <tbody v-else>
                  <tr>
                    <td
                      class="valign-middle tx-center tx-uppercase tx-bold pd-5"
                      :colspan="tableColumnCount"
                    >
                      Nenhuma conquista foi encontrada!
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td
                      class="valign-middle tx-center tx-right"
                      :colspan="totalLabelColspan"
                    >
                      Valor Total
                    </td>
                    <td class="valign-middle tx-center tx-right">
                      {{
                        totalValuesOfConquests | numeralFormat("0,0.00")
                      }}
                    </td>
                    <td class="valign-middle tx-center tx-right"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";

import config from "@/config.js";

import { mapState } from "vuex";

import moment from "moment";
import JsonExcel from "vue-json-excel";
import ProcessService from "../../../../services/ProcessService";

export default {
  name: "OperationalConquests",
  components: {
    DatePicker,
    "download-excel": JsonExcel,
  },
  data() {
    return {
      filter: {
        customers: [],
        team: null,
        date: {
          start: moment().startOf("month").toDate(),
          end: moment().endOf("month").toDate(),
        },
      },
      listOfCustomers: [],
      listOfTeams: [],
      listOfResults: [],
      excelFields: {
        Processo: "Processo",
        Cliente: "Cliente",
        Time: "Time",
        Descrição: "Descrição",
        Data: "Data",
        Origem: "Origem",
        Tipo: "Tipo",
        "Valor R$": "Valor R$",
        "Criada por": "Criada por",
      },
    };
  },

  methods: {
    getCustomerName(conquest) {
      if (!conquest.customer) {
        return "-";
      }
      return conquest.customer.name
        ? conquest.customer.name
        : conquest.customer.completeName;
    },
    stripHtml(html) {
      if (!html) {
        return "";
      }
      return String(html).replace(/<[^>]*>/g, "");
    },
    formatCurrency(value) {
      const numeralFormat = this.$options.filters.numeralFormat;
      if (numeralFormat) {
        return numeralFormat(value, "0,0.00");
      }
      return value;
    },
    mapResultToExcelRow(conquest) {
      return {
        Processo: conquest.process
          ? ProcessService.getTypeOfProcessReference(conquest.process)
          : "",
        Cliente: this.getCustomerName(conquest),
        Time: conquest.team && conquest.team.name ? conquest.team.name : "",
        Descrição: this.stripHtml(conquest.description),
        Data: conquest.date ? moment(conquest.date).format("DD/MM/YYYY") : "",
        Origem: conquest.source || "",
        Tipo: conquest.type || "",
        "Valor R$": this.formatCurrency(conquest.value),
        "Criada por": conquest.createdBy || "",
      };
    },
    keepOpen(event) {
      event.preventDefault();
      if (
        event.target &&
        (event.target.tagName === "A" || event.target.tagName === "UL")
      ) {
        const dropdowns = document.querySelectorAll(".dropdown-menu");
        dropdowns.forEach((dropdown) => {
          dropdown.classList.remove("show");
        });
      }
    },
    generate() {
      const { filter } = this;

      if (
        !filter.date.start ||
        filter.date.start === "" ||
        !filter.date.end ||
        filter.date.end === ""
      ) {
        Swal.fire(
          "Relatório de Conquistas",
          "Você precisa selecionar um período para conseguir gerar o relatório.",
          "error"
        );
        return;
      }

      this.$store.commit("setLoading", {
        show: true,
        label: "Relatório de Conquistas",
        description: "Aguarde enquanto o relatório está sendo gerado...",
      });

      const params = {
        startDate: this.$moment(filter.date.start).format("YYYY-MM-DD"),
        endDate: this.$moment(filter.date.end).format("YYYY-MM-DD"),
      };

      if (filter.customers.length > 0) {
        params.customersIds = filter.customers.map((c) => c.id).join();
      }

      if (filter.team && filter.team.id) {
        params.teamId = filter.team.id;
      }

      Axios.get(`${config.env.API_DEFAULT.host}/conquests/generalReport`, {
        params,
      })
        .then((response) => {
          if (response.data.code === "SUCCESS") {
            this.listOfResults = response.data.data || [];
            this.$store.commit("setLoading", { show: false });
            Swal.fire(
              "Relatório de Conquistas",
              `Foram encontradas ${this.listOfResults.length} conquistas de acordo com o filtro acima.`,
              "success"
            );
          } else {
            this.$store.commit("setLoading", { show: false });
            Swal.fire(
              "Relatório de Conquistas",
              response.data.message,
              "error"
            );
          }
        })
        .catch(() => {
          this.$store.commit("setLoading", { show: false });
          Swal.fire(
            "Relatório de Conquistas",
            "Houve um erro ao gerar o relatório.",
            "error"
          );
        });
    },
    async getTeams(search) {
      const response = await this.$store.dispatch(
        "ProcessStore/getTeams",
        search
      );

      if (!response) {
        Swal.fire(
          "Times Operacionais",
          "Ops, houve algum erro no carregamento dos times!",
          "error"
        );
      }
    },
    async getCustomers(search) {
      const response = await this.$store.dispatch(
        "ProcessStore/getCustomers",
        search
      );

      if (!response) {
        Swal.fire(
          "Clientes",
          "Ops, houve algum erro no carregamento dos clientes!",
          "error"
        );
      }
    },
    async findProcessByIdentificationSearch(processReference) {
      try {
		if (!processReference) {
			Swal.fire("Processo de Importação", "A referência não pode ser nula ou vazia", "error");
			return;
		}
		const processReferenceNumbersOnly = processReference.toString().replace(/\D/g, '');
		const route = this.$router.resolve(`/operational/imp/desk?showProcess=true&identification=${processReferenceNumbersOnly}`);
		window.open(route.href, '_blank');

      } catch (error) {
        Swal.fire("Processo de Importação", error.response, "error");
      }
    },
  },
  computed: {
    ProcessService() {
      return ProcessService;
    },
    showCustomerColumn() {
      return this.filter.customers.length !== 1;
    },
    tableColumnCount() {
      return this.showCustomerColumn ? 9 : 8;
    },
    totalLabelColspan() {
      return this.showCustomerColumn ? 7 : 6;
    },
    totalValuesOfConquests() {
      return (this.listOfResults || []).reduce((sum, row) => {
        const v = parseFloat(row.value);
        return sum + (Number.isFinite(v) ? v : 0);
      }, 0);
    },
    excelData() {
      if (!this.listOfResults || this.listOfResults.length === 0) {
        return [];
      }

      const rows = this.listOfResults.map((result) =>
        this.mapResultToExcelRow(result)
      );

      rows.push({
        Processo: "",
        Cliente: "",
        Time: "",
        Descrição: "",
        Data: "",
        Origem: "",
        Tipo: "Valor Total",
        "Valor R$": this.formatCurrency(this.totalValuesOfConquests),
        "Criada por": "",
      });

      return rows;
    },
    ...mapState({
      optionsCustomers: (state) => state.ProcessStore.optionsCustomers,
      optionsTeams: (state) => state.ProcessStore.optionsTeams,
    }),
  },
};
</script>

<style scoped>
.vs__selected-options span.selected-tag {
  margin: 5px 0px 0px -3px !important;
  padding: 5px !important;
}
</style>
